module.exports = __webpack_public_path__ + "static/media/rx_vector.12b7efea.svg";